import { TableFromFile } from '../../Tsv_parser';
import { useText } from '../../../../hooks/useText';

export const StatisticsTable = () => {
  const version = process.env.REACT_APP_RELEASE_VERSION || 'v253';
  const suffix = version === 'v254' ? '_v254' : '';

  const titleGDAs = useText('about.statistics.gdas_title');
  const titleVDAs = useText('about.statistics.vdas_title');
  const titleCoverage = useText('about.statistics.coverage_title');
  const titleProteinClasses = useText('about.statistics.protein_classes_title');

  const labelSource = useText('about.statistics.label_source');
  const labelGenes = useText('about.statistics.label_genes');
  const labelDiseases = useText('about.statistics.label_diseases');
  const labelGDAs = useText('about.statistics.label_gdas');
  const labelVariants = useText('about.statistics.label_variants');
  const labelVDAs = useText('about.statistics.label_vdas');
  const labelEvidences = useText('about.statistics.label_evidences');

  const altTherapeuticAreas = useText('about.statistics.alt_therapeutic_areas');
  const altProteinClasses = useText('about.statistics.alt_protein_classes');

  return (
    <>
      <h3 className="mt-5 text-lg font-semibold">{titleGDAs}</h3>
      <div className="overflow-x-auto">
        <table className="table panther-table mx-2 my-2 mb-10 mr-5">
          <thead className="text-center">
            <tr>
              <th>{labelSource}</th>
              <th>{labelGenes}</th>
              <th>{labelDiseases}</th>
              <th>{labelGDAs}</th>
              <th>{labelEvidences}</th>
            </tr>
          </thead>
          <tbody className="text-center">
            <TableFromFile filePath={`/static/files/gdas_stats${suffix}.tsv`} />
          </tbody>
        </table>
      </div>

      <h3 className="mt-5 text-lg font-semibold">{titleVDAs}</h3>
      <div className="overflow-x-auto">
        <table className="table panther-table mx-2 my-2 mb-10 mr-5">
          <thead className="text-center">
            <tr>
              <th>{labelSource}</th>
              <th>{labelVariants}</th>
              <th>{labelDiseases}</th>
              <th>{labelVDAs}</th>
              <th>{labelEvidences}</th>
            </tr>
          </thead>
          <tbody className="text-center">
            <TableFromFile filePath={`/static/files/vdas_stats${suffix}.tsv`} />
          </tbody>
        </table>
      </div>

      <h3 className="mt-5 text-lg font-semibold">{titleCoverage}</h3>
      <img
        src="/static/images/plot_msh.svg"
        className="w-full xl:w-2/3 h-auto"
        alt={altTherapeuticAreas}
      />

      <h3 className="mt-5 text-lg font-semibold">{titleProteinClasses}</h3>
      <img
        src="/static/images/plot_dto.svg"
        className="w-full xl:w-2/3 h-auto"
        alt={altProteinClasses}
      />
    </>
  );
};
